module.exports = __webpack_public_path__ + "img/convenioSindical2.ed80376c.jpg";